module.exports = __webpack_public_path__ + "static/media/autoestima.38ef8ee5.jpg";